const moment = require('moment');

const IMPORT_DONATION_DATE_FORMAT_DISPLAY = 'a valid date or date/time';
const MIN_IMPORT_DONATION_YEAR = 1000;
const MAX_IMPORT_DONATION_YEAR = 9999;
const DATE_ONLY_PATTERN = /^(\d{1,2}\/\d{1,2}\/\d{4}|\d{4}-\d{1,2}-\d{1,2})$/;

function normalizeImportDonationDateInput(value) {
  if (typeof value !== 'string') {
    return value;
  }

  return value.trim().replace(/^[A-Za-z]{2,9}\s+/, '');
}

function isImportDonationYearInRange(parsed) {
  const year = parsed.year();
  return year >= MIN_IMPORT_DONATION_YEAR && year <= MAX_IMPORT_DONATION_YEAR;
}

function parseImportDonationDate(value) {
  const normalizedValue = normalizeImportDonationDateInput(value);
  const parsed = moment(normalizedValue);

  if (!parsed.isValid() || !isImportDonationYearInRange(parsed)) {
    return null;
  }

  if (
    typeof normalizedValue === 'string' &&
    DATE_ONLY_PATTERN.test(normalizedValue)
  ) {
    parsed.hour(12).minute(0).second(0).millisecond(0);
  }

  return parsed;
}

module.exports = {
  IMPORT_DONATION_DATE_FORMAT_DISPLAY,
  MIN_IMPORT_DONATION_YEAR,
  MAX_IMPORT_DONATION_YEAR,
  parseImportDonationDate,
};
